import { ApiTagTypes, baseApi, IPaginatedResponse } from './baseApi';
import {
    IExperiment,
    IExperimentQueryArgs,
    IExperimentResult,
    IExperimentResultQueryArgs,
} from './experimentApi.types';

const experimentApi = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (build) => ({
        listExperiments: build.query<IPaginatedResponse<IExperiment>, IExperimentQueryArgs>({
            providesTags: [ApiTagTypes.experiments],
            query: (args) => ({
                url: '/experiments/',
                params: {
                    include_intrinsic: 'true',
                    ...args,
                },
            }),
        }),
        getExperiment: build.query<IExperiment, { uuid: string }>({
            providesTags: [ApiTagTypes.experiments],
            query: (args) => ({
                url: `/experiments/${args.uuid}/`,
            }),
        }),
        listExperimentResults: build.query<IPaginatedResponse<IExperimentResult>, IExperimentResultQueryArgs>({
            providesTags: [ApiTagTypes.experimentResults],
            query: (args) => ({
                url: `/experiments/${args.uuid}/results/`,
                params: {
                    page: args.page,
                    page_size: args.page_size,
                    ordering: args.ordering,
                    state: args.state,
                    search: args.search,
                    created_before: args.created_before,
                },
            }),
        }),
        createExperiment: build.mutation<IExperiment, { uri: string }>({
            invalidatesTags: [ApiTagTypes.experiments],
            query: (data) => ({
                url: '/experiments/',
                method: 'POST',
                body: data,
            }),
        }),
    }),
});

export const {
    useListExperimentsQuery,
    useGetExperimentQuery,
    useListExperimentResultsQuery,
} = experimentApi;

export { experimentApi };
